/*
 * <notify-form> — formulário inline de aviso de reposição / descida de preço.
 *
 * Custom Element (não script solto) para sobreviver ao re-render AJAX do Theme
 * Editor. Alterna visibilidade ao receber variantChange, porque a decisão em
 * Liquid é feita no servidor e não acompanha a troca de variante.
 */
if (!customElements.get('notify-form')) {
  customElements.define(
    'notify-form',
    class NotifyForm extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-panel]');
        this.done = this.querySelector('[data-done]');
        this.error = this.querySelector('[data-error]');
        this.emailInput = this.querySelector('[data-email]');
        this.consent = this.querySelector('[data-consent]');
        this.hp = this.querySelector('[data-hp]');
        this.openButton = this.querySelector('[data-open]');
        this.submitButton = this.querySelector('[data-submit]');

        this.onOpen = this.onOpen.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.openButton?.addEventListener('click', this.onOpen);
        this.submitButton?.addEventListener('click', this.onSubmit);

        if (this.jaSubscrito()) this.mostrarJaSubscrito();
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.onOpen);
        this.submitButton?.removeEventListener('click', this.onSubmit);
      }

      get chaveLocal() {
        return `notify:${this.dataset.kind}:${this.dataset.variantId}`;
      }

      jaSubscrito() {
        try {
          const bruto = window.localStorage.getItem(this.chaveLocal);
          if (!bruto) return false;
          const { expira } = JSON.parse(bruto);
          if (Date.now() > expira) {
            window.localStorage.removeItem(this.chaveLocal);
            return false;
          }
          return true;
        } catch (erro) {
          return false;
        }
      }

      marcarSubscrito() {
        // TTL de 90 dias — evita o "já está a seguir" eterno.
        const expira = Date.now() + 90 * 24 * 60 * 60 * 1000;
        try {
          window.localStorage.setItem(this.chaveLocal, JSON.stringify({ expira }));
        } catch (erro) {
          /* modo privado: seguir sem persistir */
        }
      }

      mostrarJaSubscrito() {
        if (this.openButton) this.openButton.hidden = true;
        if (this.done) {
          this.done.hidden = false;
          this.done.querySelector('span:last-child').textContent =
            this.dataset.kind === 'price'
              ? window.notifyStrings?.alreadyPrice || ''
              : window.notifyStrings?.alreadyStock || '';
        }
      }

      onOpen() {
        if (!this.panel) return;
        this.panel.hidden = !this.panel.hidden;
        if (!this.panel.hidden) this.emailInput?.focus();
      }

      mostrarErro(texto) {
        if (!this.error) return;
        this.error.textContent = texto;
        this.error.hidden = false;
      }

      onSubmit() {
        if (this.error) this.error.hidden = true;

        // Honeypot preenchido: fingir sucesso, não submeter.
        if (this.hp && this.hp.value) {
          this.panel.hidden = true;
          this.done.hidden = false;
          return;
        }

        const email = (this.emailInput?.value || '').trim();
        if (!email || !email.includes('@')) {
          return this.mostrarErro(window.notifyStrings?.errorEmail || '');
        }
        if (!this.consent?.checked) {
          return this.mostrarErro(window.notifyStrings?.errorConsent || '');
        }

        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.disabled = true;

        fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            // O servidor recusa sem consent === true. As validações acima são só
            // de experiência de utilização — quem faz POST directo passa ao lado
            // delas, e é o servidor que tem de garantir o RGPD.
            consent: true,
            hp: this.hp?.value || '',
            kind: this.dataset.kind,
            variant_id: this.dataset.variantId,
            product_id: this.dataset.productId,
            product_title: this.dataset.productTitle,
            product_handle: this.dataset.productHandle,
            price: this.dataset.price ? Number(this.dataset.price) : undefined,
          }),
        })
          .then((resposta) => resposta.json())
          .then((dados) => {
            if (!dados.ok) throw new Error(dados.error || 'erro');
            this.panel.hidden = true;
            this.openButton.hidden = true;
            this.done.hidden = false;
            this.marcarSubscrito();
          })
          .catch(() => this.mostrarErro(window.notifyStrings?.errorGeneric || ''))
          .finally(() => {
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.disabled = false;
          });
      }
    }
  );
}

// Alterna stock/preço quando a variante muda. O Liquid decidiu no servidor;
// sem isto, mudar para uma variante disponível deixaria o botão errado à vista.
document.addEventListener('variant:change', () => {});
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (evento) => {
    const variante = evento?.data?.variant;
    if (!variante) return;
    document.querySelectorAll('notify-form').forEach((elemento) => {
      const querStock = elemento.dataset.kind === 'stock';
      elemento.classList.toggle('hidden', querStock ? variante.available : !variante.available);
      elemento.dataset.variantId = variante.id;
      if (elemento.dataset.kind === 'price') {
        elemento.dataset.price = (variante.price / 100).toFixed(2);
      }
    });
  });
}
